module.exports = __webpack_public_path__ + "img/1.061cec0b.png";